import { Component, OnInit, Inject, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { MatStepper } from '@angular/material/stepper';
import { ManikEntityFE } from 'src/app/manik-library/ManikEntityFE';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
import { IEditOptions } from '../site-edit.component';


@Component({
  selector: 'microsite-settings',
  templateUrl: './microsite-settings.component.html',
})
export class MicrositeSettingsComponent extends ManikEntityFE implements OnInit {

  seo=false;
  bak=false;
  seting=false;
  microSiteForm: FormGroup;
  SEOForm: FormGroup;
  @Input() public IsSEOEdit: boolean = false;
  @Input() public SettingsView: string = "R";
  @Input() EditOption: IEditOptions;
  public Flag: boolean = false;
  public fontFamily: IAdlFrom[];
  public template: Observable<IAdlFrom[]>;
  public SiteWidthList: Observable<IAdlFrom[]>;
  public productAdvancesOption: boolean = false;
  public ImageData: { MediaID, LGContext, ShowItems, ShowEditOptions, View } = { MediaID: "", LGContext: "BIZ", ShowItems: "NFICVYSOP", ShowEditOptions: true, View: 'R' };
  public PopulateSmartMedia: boolean = false;
  public IsRTL: boolean = false;
  private BusinessID: string | null;
  private PortalContext: string;
  public MSModel: MicrositeSettingsModel = new MicrositeSettingsModel();
  public SliderDesignerEffects: { DataValue: string; DataText: string; MicrositeSectionID: string; MicrositePluginID:string }[];
  public HeaderDesignerEffects: { DataValue: string; DataText: string; MicrositeSectionID: string; MicrositePluginID:string }[];
  public MenuDesignerEffects: { DataValue: string; DataText: string; MicrositeSectionID: string;  MicrositePluginID:string}[];
  public GoToTopDesignerEffects: { DataValue: string; DataText: string; MicrositeSectionID: string; MicrositePluginID:string }[];
  @ViewChild('stepper') public stepper: MatStepper;
  constructor(private cdRef: ChangeDetectorRef,private formBuilder: FormBuilder, private _manikEntityService: ManikEntityService,
     @Inject(DOCUMENT) public document: any) {
    super(document);
    this.microSiteForm = this.formBuilder.group({
      FontID1: [''],
      FontID2: [''],
      FontID3: [''],
      BodyWidth: [''],
      ParaPrimaryTextColor: [''],
      ParaPrimaryHdrTextColor: [''],
      ParaPrimaryHdrBGColor: [''],
      ParaSecondaryTextColor: [''],
      ParaSecondaryHdrTextColor: [''],
      ParaSecondaryHdrBGColor: [''],
      ParaTertiaryTextColor: [''],
      ParaTertiaryHdrTextColor: [''],
      ParaTertiaryHdrBGColor: [''],
      ParaTextColor: [''], ParaTextBGColor: [''], ParaTextSize: [''],
      DefaultIconColor: [''],
      DefaultIconBG: [''],
      DefaultButtonTextColor: [''],
      DefaultButtonBG: [''],
      SiteTextColor: [''],
      TextColor2: [''],
      MicrositeID: [''], SettingID: [''],
      H1TextColor: [''], H1TextBGColor: [''], H1TextSize: [''], H2TextColor: [''], H2TextBGColor: [''], H2TextSize: [''],
      H3TextColor: [''], H3TextBGColor: [''], H3TextSize: [''], H4TextColor: [''], H4TextBGColor: [''], H4TextSize: [''],
      MenuTextColor: [''], MenuTextBGColor: [''], MenuTextSize: [''], BizTitleTextColor: [''], BizTitleTextBGColor: [''],
      BizTitleTextSize: ['']
    });

    this.SEOForm = this.formBuilder.group({
      SEOPageTitle: ['', [Validators.required]],
      SEOMetaDescription: [''],
      SEOKeywords: ['', [Validators.required]],
      SettingID: ''
    });
    console.log(this.EditOption)
  }

  populateControls() {
    if (this.SettingsView!='S') {
      this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAPIRequestHeaders2("EOL", "MICROSITE.TEMPLATES"))
        .subscribe(data => {
          this.template = data.ManikJSon[0].JSon0;
        });

      this.BindEffects("SLIDER");
      this.BindEffects("HEADER");
      this.BindEffects("MENU");
      this.BindEffects("BODY_GOTOTOP");
    }

    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAddlQueryHeaders2("SEMI.QUICK", "FONT", "QGLOBAL", this.PortalContext))
      .subscribe(
        data => {
          this.fontFamily = data.ManikJSon[0].JSon0;
        });

    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareLoadHeaders2(this.BusinessID, 'MICROSITE.SETTINGS', 'BIZ', this.PortalContext))
      .subscribe(data => {
        //this.fontFamily = data.ManikJSon[0].JSon0;
        //console.log(this.fontFamily);
        let formData = data.ManikJSon[0].JSon1;
        this.SiteWidthList = data.ManikJSon[0].JSon3;
        if (formData.length > 0) {
          if (this.SettingsView=='S') {
            this.SEOForm.patchValue(formData[0]);
          }
          else {
            this.IsRTL = formData[0].IsRTL === "Y" ? true : false;
            // if (this.SettingsView === "R")
            //   this.ImageData.View = "R";
            this.ImageData.MediaID = formData[0].SiteBGMediaHandle;
            this.PopulateSmartMedia = true;
            this.microSiteForm.patchValue(formData[0]);
            sessionStorage.setItem("MicrositeID", formData[0].MicrositeID);
          }
        }
      });
  }
  OnClickBgColor(controlname) {
    console.log(controlname);
    let Controlname = controlname;
    this.microSiteForm.controls[controlname].patchValue('#FFFAFA');
    setTimeout(() => {
      this.microSiteForm.controls[controlname].setValue('');
    }, 500);
  }

  BindEffects(SectionIdentifier: string): void {
    SectionIdentifier=='BODY_GOTOTOP'?this.updateFilterParams(SectionIdentifier,  "MICROSITE"):
    this.updateFilterParams(SectionIdentifier, "0", "MICROSITE");
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("GET.SECTION.EFFECTS.BY.IDENTIFIER", "MICROSITE.DESIGNER.EFFECTS", "EOL", this.PortalContext))
      .subscribe(data => {
        let MicrositeSectionID = data.ManikJSon[0].JSon0[0].MicrositeSectionID;
        let PopulateEffect: string = "";
        if (SectionIdentifier === "SLIDER") {
          this.SliderDesignerEffects = data.ManikJSon[0].JSon0;
          PopulateEffect = "SLIDER";
        }
        else if (SectionIdentifier === "HEADER") {
          this.HeaderDesignerEffects = data.ManikJSon[0].JSon0;
          PopulateEffect = "HEADER";
        }
        else if (SectionIdentifier === "MENU") {
          this.MenuDesignerEffects = data.ManikJSon[0].JSon0;
          PopulateEffect = "MENU";
        }
        else if (SectionIdentifier === "BODY_GOTOTOP") {
          this.GoToTopDesignerEffects = data.ManikJSon[0].JSon0;
          PopulateEffect = "GOTOTOP";
        }

        this.updateFilterParams(this.BusinessID, MicrositeSectionID,data.ManikJSon[0].JSon0[0].MicrositePluginID);
        this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
          this.prepareAddlQueryHeaders2("GET.SELECTED.EFFECT", "MICROSITE.MENU", "BIZ", this.PortalContext))
          .subscribe(data => {
            if (PopulateEffect === "MENU") {
              this.MSModel.MDEffectID = data.ManikJSon[0].JSon0[0].SelectedEffectID;
            }
            else if (PopulateEffect === "HEADER") {
              this.MSModel.HDEffectID = data.ManikJSon[0].JSon0[0].SelectedEffectID;
            }
            else if (PopulateEffect === "SLIDER") {
              this.MSModel.SDEffectID = data.ManikJSon[0].JSon0[0].SelectedEffectID;
            }
            else if (PopulateEffect === "GOTOTOP") {
              this.MSModel.GoToTopEffectID = data.ManikJSon[0].JSon0[0].SelectedEffectID;
              console.log(PopulateEffect, this.MSModel.GoToTopEffectID)
            }
           console.log(PopulateEffect,data.ManikJSon[0].JSon0[0].SelectedEffectID)
          });
      });
  }

  onSelectLayout(event: any) {
    sessionStorage.setItem("MicrositeID", event.value);
  }

  refreshDataGrid(): void {
  }

  ngOnInit() {
    // this.Flag = this.EditOption.Type === "SEO" ? true : (this.IsSEOEdit ? true : false);
    this.PortalContext = this.EditOption.PortalContext;
    this.BusinessID = this.EditOption.BusinessID;
    this.populateControls();
    if(this.SettingsView=='S'){
      this.seo=true;
     this.bak=false;
     this.seting=false;
    }
    else if(this.SettingsView=='P'){
      this.seo=false;
      this.bak=false;
      this.seting=true;
    }
   else if(this.SettingsView=='B'){
     this.seo=false;
     this.bak=true;
     this.seting=false;
     }
    
  }

  submitToDataBase() {
    if (this.microSiteForm.invalid && (this.SettingsView=='P' || this.SettingsView=='B')) {
      return;
    }
    if (this.SEOForm.invalid && this.SettingsView=='S') {
      return;
    }

    this.FormSubmitted = true;
    let body: any = {};
    var operation = "";
    body = this.SettingsView=='S' ? this.SEOForm.value : this.microSiteForm.value;
    operation = (body.SettingID) ? "E" : "A";
    body["BusinessID"] = this.BusinessID;
    if (this.SettingsView!='S') {
      body["Font1String"] = this.fontFamily.find(item => item.FontID === body.FontID1).FontStr;
      body["Font2String"] = this.fontFamily.find(item => item.FontID === body.FontID2).FontStr;
      body["Font3String"] = this.fontFamily.find(item => item.FontID === body.FontID3).FontStr;
      body["IsRTL"] = this.IsRTL ? "Y" : "N";
    }
    let FormSubmittedData = JSON.stringify({ 'items': [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", FormSubmittedData,
     this.prepareManageHeaders2(operation, 'MICROSITE.SETTINGS', 'BIZ', this.PortalContext))
      .subscribe(data => {
        this.FormSubmitted = false;
        // this.populateControls();
        if (this.SettingsView !='S') {
          this.UpdateEffect(this.SliderDesignerEffects.find(item => item.DataValue === this.MSModel.SDEffectID).MicrositeSectionID, this.MSModel.SDEffectID,
          this.SliderDesignerEffects.find(item => item.DataValue === this.MSModel.SDEffectID).MicrositePluginID);
          this.UpdateEffect(this.HeaderDesignerEffects.find(item => item.DataValue === this.MSModel.HDEffectID).MicrositeSectionID, this.MSModel.HDEffectID,
          this.HeaderDesignerEffects.find(item => item.DataValue === this.MSModel.HDEffectID).MicrositePluginID);
          this.UpdateEffect(this.MenuDesignerEffects.find(item => item.DataValue === this.MSModel.MDEffectID).MicrositeSectionID, this.MSModel.MDEffectID,
          this.MenuDesignerEffects.find(item => item.DataValue === this.MSModel.MDEffectID).MicrositePluginID );
          this.UpdateEffect(this.GoToTopDesignerEffects.find(item => item.DataValue === this.MSModel.GoToTopEffectID).MicrositeSectionID,
           this.MSModel.GoToTopEffectID, this.GoToTopDesignerEffects.find(item => item.DataValue === this.MSModel.GoToTopEffectID).MicrositePluginID);
        }
        if (data.ManikJSon[0].JSon0.length>0) {
          this.SettingsView=='S' ? this.showNotification('bottom', 'right', 'success', 'SEO Updated Successfully !!!') :
            this.showNotification('bottom', 'right', 'success', 'Settings Updated Successfully !!!');
        }
        this.stepper.next();
      },
        error => this.FormSubmitted = false);
  }

  UpdateEffect(MicrositeSectionID: string, SelectedEffectID: string, ID: any): void {
    this.updateFilterParams(this.BusinessID, MicrositeSectionID, ID, SelectedEffectID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("UPDATE.EFFECT", "MICROSITE.MENU", "BIZ", this.PortalContext))
      .subscribe(data =>{
        this.populateControls();
      } );
      
  }
  ngOnChanges(){
    if (this.SettingsView!='S') {
      this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAPIRequestHeaders2("EOL", "MICROSITE.TEMPLATES"))
        .subscribe(data => {
          this.template = data.ManikJSon[0].JSon0;
        });

      this.BindEffects("SLIDER");
      this.BindEffects("HEADER");
      this.BindEffects("MENU");
      this.BindEffects("BODY_GOTOTOP");
    }

    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAddlQueryHeaders2("SEMI.QUICK", "FONT", "QGLOBAL", this.PortalContext))
      .subscribe(
        data => {
          this.fontFamily = data.ManikJSon[0].JSon0;
        });

    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareLoadHeaders2(this.BusinessID, 'MICROSITE.SETTINGS', 'BIZ', this.PortalContext))
      .subscribe(data => {
        //this.fontFamily = data.ManikJSon[0].JSon0;
        //console.log(this.fontFamily);
        let formData = data.ManikJSon[0].JSon1;
        this.SiteWidthList = data.ManikJSon[0].JSon3;
        if (formData.length > 0) {
          if (this.SettingsView=='S') {
            this.SEOForm.patchValue(formData[0]);
          }
          else {
            this.IsRTL = formData[0].IsRTL === "Y" ? true : false;
            // if (this.SettingsView === "R")
            //   this.ImageData.View = "R";
            this.ImageData.MediaID = formData[0].SiteBGMediaHandle;
            this.PopulateSmartMedia = true;
            this.microSiteForm.patchValue(formData[0]);
            sessionStorage.setItem("MicrositeID", formData[0].MicrositeID);
          }
        }
      });
  }
  

  get frmSeo() {
    return this.SEOForm.controls;
  }
}

//interface IAdlFrom {
//    DataValue: string;
//    DataText: string;
//}

interface IAdlFrom {
  FontID: string,
  FontIdentifier: string,
  FontName: string,
  ImportString: string,
  FontString: string,
  UseInApp: string,
  UseOnWeb: string,
  UseInIdentityKit: string,
  FontStr: string,
  FontURL: string
}


class MicrositeSettingsModel {
  SDEffectID: string = "";
  HDEffectID: string = "";
  MDEffectID: string = "";
  GoToTopEffectID: string = "";
}
